import React from 'react';
import { createRoot } from 'react-dom/client';

import './styles.css';
import { App } from './app/App';
import { initHostBridge, reportResize } from './embed/host-bridge';

initHostBridge();

const container = document.getElementById('root')!;
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Reportar alto al host para que el iframe se autoajuste.
const ro = new ResizeObserver(() => reportResize(document.body.scrollHeight));
ro.observe(document.body);
